@if (pros.length > 0) {
  <tidy-card>
    @if (!edittingReview) {
      @for (pro of feedback; track pro; let first = $first) {
        <ng-container class="extra-bottom-padding">
          @if (pro?.data?.homekeeper_job_feedback !== null) {
            <tidy-row>
              <tidy-text
                [body]="'You Reviewed'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="pro?.data?.homekeeper?.first_name + ':'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="pro?.data?.homekeeper_job_feedback.type === 'positive' ? 'Loved It' : 'Needs Work'" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'Edit'"
                      (action)="editReview(pro)"
                      class="link" />
                  </tidy-row>
                }
                @if (pro?.data?.homekeeper_job_feedback === null) {
                  <tidy-row class="extra-bottom-padding" [align]="'center'">
                    <tidy-text
                      [title]="'Rate'" /><span>&nbsp;</span>
                      <tidy-text
                        [title]="pro?.data?.homekeeper?.first_name + ('\'s' | translate)" /><span>&nbsp;</span>
                        <tidy-text
                          [title]="'Job'" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-grid>
                          <ion-row>
                            <ion-col size="2" />
                            <ion-col size="4">
                              <tidy-round-button
                                class="black"
                                [image]="'assets/img/icons/thumb-down.svg'"
                                (action)="needsWork(pro)"
                                [label]="'Needs Work'" />
                            </ion-col>
                            <ion-col size="4">
                              <tidy-round-button
                                class="green"
                                [image]="'assets/img/icons/white-heart.svg'"
                                (action)="lovedIt(pro)"
                                [label]="'Love It'" />
                            </ion-col>
                            <ion-col size="2" />
                          </ion-row>
                        </tidy-grid>
                      </tidy-row>
                    }
                  </ng-container>
                }
              }
              @if (edittingReview) {
                <tidy-row class="extra-bottom-padding" [align]="'center'">
                  <tidy-text
                    [title]="'Rate'" /><span>&nbsp;</span>
                    <tidy-text
                      [title]="edittingPro?.data?.homekeeper?.first_name + ('\'s' | translate)" /><span>&nbsp;</span>
                      <tidy-text
                        [title]="'Job'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-grid>
                        <ion-row>
                          <ion-col size="2" />
                          <ion-col size="4">
                            <tidy-round-button
                              class="black"
                              [image]="'assets/img/icons/thumb-down.svg'"
                              (action)="needsWork(edittingPro)"
                              [label]="'Needs Work'" />
                          </ion-col>
                          <ion-col size="4">
                            <tidy-round-button
                              class="green"
                              [image]="'assets/img/icons/white-heart.svg'"
                              (action)="lovedIt(edittingPro)"
                              [label]="'Love It'" />
                          </ion-col>
                          <ion-col size="2" />
                        </ion-row>
                      </tidy-grid>
                    </tidy-row>
                  }
                </tidy-card>
              }
